import { type UseFormReturnType } from '@mantine/form'
import { useState } from 'react'

import { type CoreBookingProduct, type UNSAFE_any } from '@flecto/types'

type UseResetCustomValueProps = {
  form: UseFormReturnType<UNSAFE_any>
  setResetCustomValue: (value: boolean) => void
  resetCustomValue: boolean
}

export function useResetCustomValue({
  form,
  setResetCustomValue,
  resetCustomValue,
}: UseResetCustomValueProps) {
  const [originalValue] = useState<CoreBookingProduct>({
    ...form.values,
  })

  const handleResetCustomValue = () => {
    if (resetCustomValue) {
      try {
        form.setValues(originalValue)
      } catch (error) {
        console.error(error)
      } finally {
        setResetCustomValue(false)
      }
    }
  }

  const handleResetPricingTier = () => {
    form.setFieldValue('pricing_tier', originalValue.pricing_tier)
  }

  return { handleResetCustomValue, handleResetPricingTier }
}
